import { useFields } from '@/routes/hooks/useFields';
import { BillSize, StepName } from '@/state/state.types';
import { shouldShowSalesBannerByStepId } from '@/utils/showLayoutElements';
import { SalesBanner } from './SalesBanner';

export const CheckAndDisplaySalesBanner = (stepId: string) => {
  const fields = useFields();

  const isValidPath = [StepName.medical_provider_name, StepName.in_collections].includes(stepId);

  if (
    !isValidPath ||
    !BillSize.exclude([BillSize.Enum['less-than-5k']]).safeParse(fields?.['bill-size']).success
  )
    return null;

  return shouldShowSalesBannerByStepId(stepId) && <SalesBanner stepId={stepId} />;
};
